var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Prueba de Filtro de Actividad" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c(
        "ContenidoModal",
        [
          _c(
            "v-flex",
            { attrs: { md10: "" } },
            [
              _c(
                "v-card",
                { staticClass: "rounded-card" },
                [
                  _c("v-container", { attrs: { "grid-list-md": "" } }, [
                    _c(
                      "table",
                      { attrs: { id: "tFiltro", "aria-hidden": "true" } },
                      [
                        _c("tr", [
                          _c("th", { attrs: { id: "thActividad" } }, [
                            _vm._v("Actividad")
                          ]),
                          _c("th", { attrs: { id: "thFiltro" } }, [
                            _vm._v("Filtro")
                          ]),
                          _c("th", { attrs: { id: "thResultado" } }, [
                            _vm._v("Resultado")
                          ])
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c("v-textarea", {
                                attrs: { solo: "", rows: 3 },
                                model: {
                                  value: _vm.formFields.actividad1.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.actividad1,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.actividad1.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "td",
                            { attrs: { rowspan: "2" } },
                            [
                              _c("v-textarea", {
                                attrs: { solo: "", rows: 10 },
                                model: {
                                  value: _vm.script,
                                  callback: function($$v) {
                                    _vm.script = $$v
                                  },
                                  expression: "script"
                                }
                              })
                            ],
                            1
                          ),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.formFields.resultado1.value))
                            ])
                          ])
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c("v-textarea", {
                                attrs: { solo: "", rows: 3 },
                                model: {
                                  value: _vm.formFields.actividad2.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.actividad2,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.actividad2.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("td", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.formFields.resultado2.value))
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }